import {useMobileDevicePortrait} from './useMobileDevicePortrait';
import {useMobileDeviceLandscape} from './useMobileDeviceLandscape';

export const useMobileDevice = () => {
    const isPortrait = useMobileDevicePortrait();
    const isLandscape = useMobileDeviceLandscape();
    return isPortrait || isLandscape;
};
